/*
by zhang.qiang 2017/02/21
 */
"use strict";
angular.module('zjPublicopinionModule', ["planTimeCueDetailModule"])
    .controller('zjPublicopinionCtrl', ['$scope', 'trsHttpService', function ($scope, trsHttpService) {
        initStatus();
        initData();
        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                "CURRPAGE": 1,
                "PAGESIZE": 20,
                "PAGECOUNT": 1,
            };
            $scope.status = {
                copyCurrPage: 1,
                column: 0,
                region: { name: '全部地域', value: '' },
                keywords: "",
                regionJsons: [
                    { name: '全部地域', value: '' },
                    { name: '新疆舆情', value: '新疆' },
                    { name: '杭州舆情', value: '杭州市' },
                    { name: '宁波舆情', value: '宁波市' },
                    { name: '温州舆情', value: '温州市' },
                    { name: '湖州舆情', value: '湖州市' },
                    { name: '嘉兴舆情', value: '嘉兴市' },
                    { name: '绍兴舆情', value: '绍兴市' },
                    { name: '金华舆情', value: '金华市' },
                    { name: '衢州舆情', value: '衢州市' },
                    { name: '台州舆情', value: '台州市' },
                    { name: '丽水舆情', value: '丽水市' },
                    { name: '舟山舆情', value: '舟山市' }
                ],
                timeType: {
                    name: "",
                    value: ""
                },
                params: {
                    "OperTime": ""
                }
            };
            $scope.data = {
                items: []
            };

        }

        /**
         * [queryByDropdown description] 筛选条件触发后请求数据
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */
        $scope.queryByDropdown = function (key, value) {
            $scope.status.params[key] = value;
            $scope.status.params.CurrPage = $scope.status.copyCurrPage = $scope.page.CURRPAGE = "1";
            if (key == 'OperTime') {
                $scope.status.params[key] = null;
                $scope.status.params.OperTimeStart = $scope.data.fromDate;
                $scope.status.params.OperTimeEnd = $scope.data.untilDate;
                $scope.status.timeType.value = $scope.data.fromDate + "," + $scope.data.untilDate;
            }
            requestData();
        };



        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
        }
        /**
         * [requestData 请求数据]
         * @return {[type]} [description]
         */
        function requestData() {
            var params = {
                "serviceid": "globalsen",
                "modelid": "sentimentmaparealist",
                "typeid": "widget",
                zbtype: $scope.status.column,
                areanm: $scope.status.region.value,
                search_date: $scope.status.timeType.value,
                searchwords: $scope.status.keywords,
                page_no: $scope.page.CURRPAGE - 1,
                page_size: $scope.page.PAGESIZE
            };//sjji
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function (data) {
                $scope.data.items = data.PAGEITEMS;
                $scope.page.ITEMCOUNT = data.TOTALITEMCOUNT - $scope.page.PAGESIZE;
                //大数据反的数据是从1开始，造成显示差20条数据
                if ($scope.page.ITEMCOUNT < 0) {
                    $scope.page.ITEMCOUNT = 0;
                }
                $scope.page.PAGECOUNT = data.TOTALPAGECOUNT - 1;
            });
        }
        /**
         * [getColumn 切换文章或微博]
         * @param  {[type]} value [description]
         * @return {[type]}       [description]
         */
        $scope.getColumn = function (value) {
            //判断是为了防止重复点击请求数据,节省资源
            if (value == "wenzhang" && $scope.status.column === 0) {
                return;
            } else if (value == "weibo" && $scope.status.column === 1) {
                return;
            } else {
                if (value == 'wenzhang') {
                    $scope.status.column = 0;
                } else {
                    $scope.status.column = 1;
                }
                $scope.status.region = $scope.status.regionJsons[0];
                //$scope.status.timeType = $scope.status.timeTypeJsons[0];
                $scope.status.keywords = "";
                $scope.status.copyCurrPage = 1;
                $scope.page.CURRPAGE = 1;
                requestData();
            }

        };
        /**
         * [getSelected 选择地区]
         * @return {[type]} [description]
         */
        $scope.getSelected = function () {
            requestData();
        };
        /**
         * [getselectTime 选择时间]1
         * @return {[type]} [description]
         */
        $scope.getselectTime = function () {
            requestData();
        };
        /**
         * [fullTextSearch 全文检索]
         * @param  {[type]} ev [description:按下空格也能提交]
         */
        $scope.fullTextSearch = function (ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.page.CURRPAGE = 1;
                requestData();
            }
        };
        /** [selectPageNum 每页显示的数据数量]
         */
        $scope.selectPageNum = function () {
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };
        /**
         * [pageChanged 下一页 页面改变调取数据]
         * @return {[type]} [description]
         */
        $scope.pageChanged = function () {
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };
    }]);
